import React from 'react';
import { wrapFunctionalComponent } from 'utils/framework';
import {
    Box, Flex, Icon, Link, Text
} from 'components/ui';
import { colors, space } from 'style/config';
import localeUtils from 'utils/LanguageLocale';
import { BEAUTY_INSIDER_TERMS_LINK } from 'constants/legal';
import { BI_PROGRAM_FAQS_URL } from 'utils/BeautyInsider';
import BiHubFooterLinksEN from 'components/Content/BeautyInsider/BiHubFooterLinks/locales/BiHubFooterLinks_en_US';
import BiHubFooterLinksFR from 'components/Content/BeautyInsider/BiHubFooterLinks/locales/BiHubFooterLinks_fr_CA';

const getText = localeUtils.getLocalisedDataFromResource(BiHubFooterLinksEN, BiHubFooterLinksFR);

const LINKS = [
    {
        id: 'faqs',
        labelKey: 'faqs',
        href: BI_PROGRAM_FAQS_URL
    },
    {
        id: 'terms',
        labelKey: 'terms',
        href: BEAUTY_INSIDER_TERMS_LINK
    }
];

const styles = {
    card: {
        backgroundColor: colors.white,
        borderRadius: 0,
        boxShadow: 'none',
        padding: 0,
        borderBottom: `1px solid ${colors.lightGray}`
    },
    row: {
        borderTop: `1px solid ${colors.lightGray}`,
        paddingTop: space[4],
        paddingBottom: space[4]
    }
};

const BiHubFooterLinks = () => (
    <Box
        marginTop={[4, 5]}
        css={styles.card}
        data-testid='bi-hub-footer-links'
    >
        {LINKS.map(link => (
            <Link
                key={link.id}
                href={link.href}
                color='black'
                display='block'
            >
                <Flex
                    alignItems='center'
                    justifyContent={['space-between', 'flex-start']}
                    gap={[0, 2]}
                    css={styles.row}
                >
                    <Text children={getText(link.labelKey)} />
                    <Icon
                        name='chevronRight'
                        size={16}
                    />
                </Flex>
            </Link>
        ))}
    </Box>
);

export default wrapFunctionalComponent(BiHubFooterLinks, 'BiHubFooterLinks');
